import { toast } from 'react-toastify';
import { SAVE_IN_PROGRESS, SAVE_PROCESS_DONE } from "./fetchingDataActions";
import { MarketPlaceCategoryDTO } from './DTOs/MarketPlaceCategoryDTO';
import { createItemWs, updateItemWs } from '../webservices/saveWS';
import { fetchItemsWS } from '../webservices/fetchWS';

export const FETCHING_LOOKUPS_ACTION = 'FETCHING_LOOKUPS_ACTION';
export const FETCH_LOOKUPS_SUCCESS_ACTION = 'FETCH_LOOKUPS_SUCCESS_ACTION';
export const FETCH_LOOKUPS_ERROR_ACTION = 'FETCH_LOOKUPS_ERROR_ACTION';

export const FETCHING_CATEGORIES_ACTION = 'FETCHING_CATEGORIES_ACTION';
export const FETCH_CATEGORIES_SUCCESS_ACTION = 'FETCH_CATEGORIES_SUCCESS_ACTION';
export const FETCH_CATEGORIES_ERROR_ACTION = 'FETCH_CATEGORIES_ERROR_ACTION';

export const CATEGORY_ADD_ACTION = 'CATEGORY_ADD_ACTION';
export const CATEGORY_EDIT_ACTION = 'CATEGORY_EDIT_ACTION';
export const CATEGORY_DELETE_ACTION = 'CATEGORY_DELETE_ACTION';

export const fetchLookupsAction = (tenant) => {
  const queryParams = {
    PK: `${tenant.id}%23LOOKUPS`,
    SK: `LOOKUP%23`,
  };

  return (dispatch, getState) => {
    dispatch({ type: SAVE_IN_PROGRESS });
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        const returnItems = result.Items.filter(item => item.status !== 'isDeleted');
        dispatch({ type: FETCH_LOOKUPS_SUCCESS_ACTION, payload: returnItems });
        dispatch({ type: SAVE_PROCESS_DONE });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: FETCH_LOOKUPS_ERROR_ACTION, err });
        dispatch({ type: SAVE_PROCESS_DONE });
      });
  };
}

export const fetchCategoriesAction = (questionaireId, tenantId) => {
  const queryParams = {
    PK: `${tenantId}%23QNAIRE%23${questionaireId}`,
    SK: 'CATEGORY%23',
  };

  return (dispatch, getState) => {
    dispatch({ type: SAVE_IN_PROGRESS });
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        const returnItems = result.Items.filter(item => item.op !== 'd');
        dispatch({ type: FETCH_CATEGORIES_SUCCESS_ACTION, payload: returnItems });
        dispatch({ type: SAVE_PROCESS_DONE });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: FETCH_CATEGORIES_ERROR_ACTION, err });
        dispatch({ type: SAVE_PROCESS_DONE });
      });
  };
}

export const categorySaveAction = (category, tenantId) => {
  return (dispatch, getState) => {
    const saveObject = new MarketPlaceCategoryDTO(category, tenantId);
    dispatch({ type: SAVE_IN_PROGRESS });
    if (category.id === undefined) {
      saveObject.status = 'active'
      createItemWs(saveObject, getState)
        .then((result) => {
          dispatch({ type: CATEGORY_ADD_ACTION, payload: result.data });
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.success('The market place category has been added successfully');
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.error('Failed to add market place category please try again');
        })
    }
    else {
      updateItemWs(saveObject, getState)
        .then((result) => {
          dispatch({ type: CATEGORY_EDIT_ACTION, payload: result.data });
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.success('The market place category has been updated successfully');
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.error('Failed to update market place category please try again');
        })
    }
  }
}

export const categoryDeleteAction = (category) => {
  return (dispatch, getState) => {
    const saveObject = new MarketPlaceCategoryDTO(category);
    saveObject.status = 'isDeleted';
    updateItemWs(saveObject, getState)
      .then((result) => {
        dispatch({ type: CATEGORY_DELETE_ACTION, payload: result.data.id });
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.success('The market place category has been deleted successfully');
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.error('Failed to delete market place category please try again');
      })
  }
}
